import styled from '@emotion/styled'
import theme from '@utils/theme'

export const CustomerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: start;
`

export const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`

export const CustomerDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 4px;
`

export const Name = styled.span`
  font-weight: 600;
`

export const Email = styled.span`
  font-size: 0.75rem;
  color: ${theme.colors.text50};
`

export const FieldTwoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const FieldText = styled.p`
  margin: 0;
  font-size: 0.875rem;
`

export const AddOnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const AddOnPoints = styled.span`
  font-size: 0.75rem;
  color: ${theme.colors.text50};
`

export const DateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const DateText = styled.span`
  font-size: 0.875rem;
`
